// Initialize homepage featured slider
function initializeHomepageFeaturedSlider() {
  $('.homepage-featured-slider').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    appendArrows: $('.homepage-featured-slider-container'),
    prevArrow: '<a href="#" class="homepage-featured-slider-nav homepage-featured-slider-prev"><i class="fa fa-chevron-left fa-lg"></i>&nbsp;</a>',
    nextArrow: '<a href="#" class="homepage-featured-slider-nav homepage-featured-slider-next"><i class="fa fa-chevron-right fa-lg"></i>&nbsp;</a>',
    dots: true,
    dotsClass: 'homepage-featured-slider-dots',
    appendDots: $('.homepage-featured-slider-container'),
    easing: 'swing',
    slidesToShow: 1,
    infinite: true,
    mobileFirst: true,
    draggable: false,
    swipe: true,
    responsive: [
    {
      breakpoint: 544,
      settings: {
        prevArrow: '<a href="#" class="homepage-featured-slider-nav homepage-featured-slider-prev"><i class="fa fa-chevron-left fa-2x"></i>&nbsp;</a>',
        nextArrow: '<a href="#" class="homepage-featured-slider-nav homepage-featured-slider-next"><i class="fa fa-chevron-right fa-2x"></i>&nbsp;</a>',
      }
    }]
  });

}; // initializeHomepageFeaturedSlider()

// Initialize homepage latest stories slider
function initializeHomepageLatestStoriesSlider() {
  $('.latest-stories-slider').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    appendArrows: $('.latest-stories-slider-container'),
    prevArrow: '<a href="#" class="latest-stories-slider-nav latest-stories-slider-prev"><i class="fa fa-chevron-left fa-lg"></i>&nbsp;</a>',
    nextArrow: '<a href="#" class="latest-stories-slider-nav latest-stories-slider-next"><i class="fa fa-chevron-right fa-lg"></i>&nbsp;</a>',
    dots: true,
    dotsClass: 'latest-stories-slider-dots',
    appendDots: $('.latest-stories-slider-container'),
    easing: 'swing',
    slidesToShow: 1,
    infinite: true,
    mobileFirst: true,
    draggable: false,
    swipe: true,
    responsive: [
    {
      breakpoint: 544,
      settings: {
        prevArrow: '<a href="#" class="latest-stories-slider-nav latest-stories-slider-prev"><i class="fa fa-chevron-left fa-2x"></i>&nbsp;</a>',
        nextArrow: '<a href="#" class="latest-stories-slider-nav latest-stories-slider-next"><i class="fa fa-chevron-right fa-2x"></i>&nbsp;</a>',
      }
    }]
  });

}; // initializeHomepageLatestStoriesSlider()

if ( $('body').hasClass('page-template-page-homepage') ) {
  // Homepage Main Slider
  initializeHomepageFeaturedSlider();
  // Homepage Latest Stories Slider
  initializeHomepageLatestStoriesSlider();

  // Reinitialize sliders on resize or orientation change
  $(window).on('resize orientationchange', function() {
    $('.homepage-featured-slider').slick('resize');
    $('.latest-stories-slider').slick('resize');
  });

  // Bind video play click
  $('.homepage-featured-slider').on('click', '.btn-video-play', function(e) {
    e.preventDefault();
    e.stopPropagation();

    // Pause slider
    $('.homepage-featured-slider').slick('slickPause');

    // Get YouTube ID
    var youtubeId = $(this).data('youtube-id'),
        videoFrame = '<iframe width="560" height="315" src="https://www.youtube.com/embed/' + youtubeId + '?rel=0&amp;showinfo=0&amp;autoplay=1" frameborder="0" gesture="media" allow="encrypted-media" allowfullscreen></iframe>',
        title = $(this).siblings('.featured-slide-text').find('h5').text();

    openModal('#cpatch-video-modal', videoFrame, '');
  });
}